import React, {useCallback, useState} from 'react'
import {InputCheckbox} from "../../checkbox/InputCheckbox";
import { allTimezones } from '../../../timezone';


export function StartNodeStart({form, errors, loading, setForm, setErrors}) {

    const [triggerTypes] = useState([
        { key: "", text: "Без типа (по умолчанию)", value: "" },
        { key: "T", text: "Временной триггер", value: "T" },
        { key: "E", text: "Событийный триггер", value: "E" },
    ]);

    const [periodicityTypes] = useState([
        { key: "N", text: "Запуск единожды", value: "N" },
        { key: "D", text: "Указанный день", value: "D" },
        { key: "E", text: "Ежедневно", value: "E" },
        { key: "W", text: "Еженедельно", value: "W" },
        { key: "M", text: "Ежемесячно", value: "M" },
    ]);

    const [eventTypes] = useState([
        { key: "", text: "Выберите событие", value: "" },
        { key: "REG_WITH_PHONE", text: "Регистрация клиента", value: "REG_WITH_PHONE" },
        { key: "REG_NO_PHONE", text: "Регистрация клиента без телефона в профиле", value: "REG_NO_PHONE" },
        { key: "STAGE_END", text: "Завершение этапа курса", value: "STAGE_END" },
        { key: "COURSE_STATUS", text: "Изменение статуса курса", value: "COURSE_STATUS" },
        { key: "NEW_MESSAGE", text: "Нового сообщения от клиента", value: "NEW_MESSAGE" },
        { key: "NEW_MESSAGE_CURATOR", text: "Нового сообщения от куратора", value: "NEW_MESSAGE_CURATOR" },
        { key: "COURSE_START_FUTURE", text: "Старт курса в будущем", value: "COURSE_START_FUTURE" },
        { key: "COURSE_START_PAST", text: "Старт курса в прошлом", value: "COURSE_START_PAST" },
        { key: "COURSE_START_NOW", text: "Старт курса", value: "COURSE_START_NOW" },
        { key: "COURSE_RETURN", text: "Возврат курса или продукта", value: "COURSE_RETURN" },
        { key: "ACCESS_CURATOR_RESTORED", text: "Доступ к куратору восстановлен", value: "ACCESS_CURATOR_RESTORED" },
        { key: "COURSE_PART2", text: "2 часть курса", value: "COURSE_PART2" },
        { key: "COURSE_PART3", text: "3 часть курса", value: "COURSE_PART3" },
        { key: "COURSE_FINISH", text: "Курс завершен", value: "COURSE_FINISH" },
        { key: "NEW_CLIENT", text: "У куратора новый клиент", value: "NEW_CLIENT" },
        { key: "WELCOME", text: "Начальные инструкции", value: "WELCOME" },
        { key: "NEW_CLIENT_AFTER_TEST", text: "Новый клиент после тестовой недели", value: "NEW_CLIENT_AFTER_TEST" },
        { key: "CLIENT_SAVE_HEALTH", text: "Клиент заполнил анкету здоровья", value: "CLIENT_SAVE_HEALTH" },
        { key: "CLIENT_SAVE_CONTROL", text: "Клиент заполнил анкету контроля", value: "CLIENT_SAVE_CONTROL" },
        { key: "EATING_DETOX_EXPRESS", text: "Отправить режимы питания клиентов Detox Express", value: "EATING_DETOX_EXPRESS" },
        { key: "EATING_MARATHON", text: "Отправить режимы питания клиентов Marathon", value: "EATING_MARATHON" },
        { key: "EATING_BALANCE", text: "Отправить режимы питания клиентов Balance", value: "EATING_BALANCE" },
        { key: "CURATOR_RESTRICTED", text: "Доступ к куратору ограничен", value: "CURATOR_RESTRICTED" },
        { key: "CURATOR_ARCHIVE", text: "Доступ к куратору ограничен архив", value: "CURATOR_ARCHIVE" },
        { key: "CLIENT_SET_HEALTH", text: "Не заполнена анкета здоровья", value: "CLIENT_SET_HEALTH" },
        { key: "COURSE_UP_FUTURE", text: "Курс обновлен, старт в будущем", value: "COURSE_UP_FUTURE" }
    ]);

    const handleChangeCheckbox = (name) => {
        setForm({...form, [name]: !form[name]});
        setErrors({...errors, [name]: !form[name] ? '' : true});
    };

    const handleChangeForm = useCallback((e) => {
      const name = e.target.name;
      const value = e.target.value;
      setForm({...form, [name]: value});
    }, [form, setForm]);

    return <>
        <div className="profile__wrap">
            <div className="profile__group">
                <label className="profile__label help">Тип триггера</label>
                <select
                    className={`dropdown__select select ${errors.type ? 'is-invalid' : ''}`}
                    name="trigger_type"
                    value={form.trigger_type}
                    onChange={handleChangeForm}
                >
                    {triggerTypes.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.text}
                        </option>
                    ))}
                </select>
            </div>

            {form.trigger_type === 'T' && <>
                <div className="profile__group">
                    <label className="profile__label help">Периодичность</label>
                    <select
                        className={`dropdown__select select ${errors.type ? 'is-invalid' : ''}`}
                        name="periodicity"
                        value={form.periodicity}
                        onChange={handleChangeForm}
                    >
                        <option value="">пожалуйста выберите</option>
                        {periodicityTypes.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.text}
                            </option>
                        ))}
                    </select>
                </div>

                {(form.periodicity === 'W' || form.periodicity === 'M' || form.periodicity === 'E') && <div className="profile__group">
                    <label className="profile__label help">Запускать {form.periodicity === 'W' ? 'каждую' : 'каждый'} N-й {form.periodicity === 'W' ? 'неделю' : form.periodicity === 'M' ? 'месяц' : 'день'}</label>
                    <input type="number" name="period_delay" value={form.period_delay} onChange={handleChangeForm} className="profile__input input" />
                </div>}

                {form.periodicity === 'D' && <div className="profile__group">
                    <label className="profile__help help">Дата запуска</label>
                    <div className="profile__group" style={{display: 'flex', gap: '10px'}}>
                        <input
                            type="date"
                            className="profile__input input"
                            value={form.run_date || ''}
                            onChange={handleChangeForm}
                            name="run_date"
                        />
                    </div>
                </div>}

                <div className="profile__group">
                    <label className="profile__help help">Время</label>
                    <div className="profile__group">
                        <input aria-label="Time" type="time" name="run_time" value={form.run_time} onChange={handleChangeForm} className="profile__input input input-time" />
                    </div>
                </div>

                {(form.periodicity === 'W') && <div className="profile__wrap" style={{display: 'flex', flexDirection: 'row', gap: '10px', paddingTop: '0px'}}>
                    <InputCheckbox title="Понедельник" name="monday" checked={form.monday} onChange={() => handleChangeCheckbox('monday')}/>
                    <InputCheckbox title="Вторник" name="tuesday" checked={form.tuesday} onChange={() => handleChangeCheckbox('tuesday')}/>
                    <InputCheckbox title="Среда" name="wednesday" checked={form.wednesday} onChange={() => handleChangeCheckbox('wednesday')}/>
                    <InputCheckbox title="Четверг" name="thursday" checked={form.thursday} onChange={() => handleChangeCheckbox('thursday')}/>
                    <InputCheckbox title="Пятница" name="friday" checked={form.friday} onChange={() => handleChangeCheckbox('friday')}/>
                    <InputCheckbox title="Суббота" name="saturday" checked={form.saturday} onChange={() => handleChangeCheckbox('saturday')}/>
                    <InputCheckbox title="Воскресенье" name="sunday" checked={form.sunday} onChange={() => handleChangeCheckbox('sunday')}/>
                </div>}
            </>}
            {form.trigger_type === 'E' && <>
                <div className="profile__group">
                    <label className="profile__label help">Тип события</label>
                    <select
                        className={`dropdown__select select ${errors.type ? 'is-invalid' : ''}`}
                        name="event_type"
                        value={form.event_type}
                        onChange={handleChangeForm}
                    >
                        {eventTypes.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.text}
                            </option>
                        ))}
                    </select>
                </div>
            </>}
        </div>

        <div className="profile__wrap">
            <div className="profile__group">
                <label className="profile__label help">Задержка между запусками, сек</label>
                <input type="number" name="delay" value={form.delay} onChange={handleChangeForm} className="profile__input input" />
            </div>
            <div className="profile__group">
                <label className="profile__label help">Часовой пояс</label>
                <select
                    className={`dropdown__select select ${errors.timezone_cfg ? 'is-invalid' : ''}`}
                    name="timezone_cfg"
                    value={form.timezone_cfg}
                    onChange={handleChangeForm}
                >
                    <option value="">пожалуйста выберите</option>
                    {Object.keys(allTimezones).map(k => (
                        <option key={k} value={k}>
                            {allTimezones[k]}
                        </option>
                    ))}
                </select>
            </div>
        </div>
        <div className="profile__wrap">
            <div className="profile__group">
                <label className="profile__help help">Дата начала</label>
                <div className="profile__group" style={{display: 'flex', gap: '10px'}}>
                    <input
                        type="date"
                        className="profile__input input"
                        value={form.start_date || ''}
                        onChange={handleChangeForm}
                        name="start_date"
                    />
                </div>
            </div>
            <div className="profile__group">
                <label className="profile__help help">Дата окончания</label>
                <div className="profile__group" style={{display: 'flex', gap: '10px'}}>
                    <input
                        type="date"
                        className="profile__input input"
                        value={form.end_date || ''}
                        onChange={handleChangeForm}
                        name="end_date"
                    />
                </div>
            </div>
        </div>
    </>;
}